import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useOnboardingWizard } from "../OnboardingWizardProvider";
import { Trophy, ArrowRight, Star } from "lucide-react";

export function CompletionStep() {
  const { t } = useTranslation();
  const {
    stepConfig,
    totalPoints,
    maxPoints,
    executeAction,
    formData,
    markStepComplete,
    currentStep,
    onStepComplete,
  } = useOnboardingWizard();

  // Auto-complete this step on mount (it's just a results page)
  const completedRef = useRef(false);
  useEffect(() => {
    if (completedRef.current) return;
    completedRef.current = true;
    markStepComplete(currentStep);
    onStepComplete(currentStep);
    executeAction({ type: "completeStep" }, { formData });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleCta = async () => {
    if (stepConfig.ctaAction) {
      await executeAction(stepConfig.ctaAction, { formData });
    }
  };

  return (
    <div className="text-center space-y-8">
      {/* Trophy */}
      <div className="mx-auto w-24 h-24 rounded-2xl bg-nara-gold/20 flex items-center justify-center">
        <Trophy className="h-12 w-12 text-nara-gold" />
      </div>

      {/* Header */}
      <div className="space-y-3">
        <h2 className="text-3xl font-bold text-foreground">
          {t(stepConfig.title)}
        </h2>
        {stepConfig.subtitle && (
          <p className="text-lg text-muted-foreground">
            {t(stepConfig.subtitle)}
          </p>
        )}
      </div>

      {/* Points summary */}
      <div className="inline-flex items-center gap-2 px-4 py-2 bg-nara-gold/15 rounded-full">
        <Star className="h-5 w-5 text-nara-gold fill-nara-gold" />
        <span className="font-bold text-foreground">{totalPoints} XP</span>
        <span className="text-muted-foreground text-sm">earned</span>
      </div>

      {/* CTA */}
      <button
        onClick={handleCta}
        className="inline-flex items-center gap-2 px-8 py-4 bg-nara-orange text-nara-charcoal font-semibold rounded-xl hover:bg-nara-orange/90 transition-colors text-lg"
      >
        {t(stepConfig.ctaLabel || "onboarding.goToDashboard")}
        <ArrowRight className="h-5 w-5" />
      </button>
    </div>
  );
}
